import { SetSelectedLabels } from '@modules/feedback/types';
import { Tooltip, Typography } from '@mui/material';
import { Category } from '@modules/common/types';
import { Feedback, FeedbackLabel } from 'v2/core/entities/feedback';
import { FeedbackTruncatedLabelsTooltipContent } from './FeedbackTruncatedLabelsTooltipContent';

interface FeedbackTruncatedLabelsProps {
  category: Category;
  feedback: Feedback;
  totalLabelsLength: number;
  truncationLength: number;
  selectedLabels: FeedbackLabel[];
  remainingLabels: FeedbackLabel[];
  setSelectedLabels?: SetSelectedLabels;
  isLabelsSelectionDisabled?: boolean;
  onFeedbackCardLabelClick?: (selectedLabels: FeedbackLabel[]) => void;
  disableLabelSelection?: boolean;
  disabledLabelIDs?: string[];
}

export const FeedbackTruncatedLabels = ({
  category,
  feedback,
  totalLabelsLength,
  truncationLength,
  remainingLabels,
  setSelectedLabels,
  selectedLabels,
  isLabelsSelectionDisabled,
  onFeedbackCardLabelClick,
  disableLabelSelection,
  disabledLabelIDs,
}: FeedbackTruncatedLabelsProps) => {
  return (
    <Tooltip
      title={
        <FeedbackTruncatedLabelsTooltipContent
          category={category}
          feedback={feedback}
          remainingLabels={remainingLabels}
          selectedLabels={selectedLabels}
          disableLabelSelection={disableLabelSelection}
          disabledLabelIDs={disabledLabelIDs}
          isLabelsSelectionDisabled={isLabelsSelectionDisabled}
          onFeedbackCardLabelClick={onFeedbackCardLabelClick}
          setSelectedLabels={setSelectedLabels}
        />
      }
      placement="top-start"
      componentsProps={{
        tooltip: {
          sx: {
            p: 0,
          },
        },
      }}
    >
      <Typography variant="button" color="primary">
        +{totalLabelsLength - truncationLength}
      </Typography>
    </Tooltip>
  );
};
